const createDeleteItemInArray = (stateValue, fieldToFilter) => {
  return (state, action) => {
    const arrayFiltered = state[stateValue].filter(
      item => item[fieldToFilter] !== action.payload[fieldToFilter],
    );
    return {
      ...state,
      [stateValue]: arrayFiltered,
    };
  };
};

export default createDeleteItemInArray;



// WEBPACK FOOTER //
// src/redux/reducers/functions/createDeleteItemInArray.js